import ViewUserEmailsAndDnsdDetailsContainer from "./ViewUserEmailsAndDnsdDetailsContainer";

export default ViewUserEmailsAndDnsdDetailsContainer;
